import { TradeProposalId } from "@fartherfinance/frontend/api/Investment/types";
import {
  Custodian,
  CustodianAccountId,
} from "@fartherfinance/frontend/api/Types";

const ProposalFilterOptions = [
  "Active Proposals",
  "Active Immaterial Proposals",
  "All Expired Proposed Proposals",
  "All Expired Proposals",
  "All Submitted Proposals",
  "All Skipped Proposals",
  "All Proposals",
] as const;

type ProposalFilter = typeof ProposalFilterOptions[number];

type ProposalLocationState =
  | ({
      proposalIds?: TradeProposalId[];
      proposalFilter?: ProposalFilter;
      page?: number;
    } & { custodian?: Custodian | null } & Params)
  | undefined;

const BundleFilterOptions = [
  "Active Bundles",
  "Submitted Bundles",
  "Expired Bundles",
  "All Bundles",
] as const;
type BundleFilter = typeof BundleFilterOptions[number];

type BundleLocationState =
  | { proposalFilter?: BundleFilter; page?: number }
  | undefined;

interface Params {
  custodianAccountId?: CustodianAccountId | null;
  createdAtGt?: Date | null;
  createdAtLt?: Date | null;
}

export {
  Params,
  ProposalFilterOptions,
  ProposalLocationState,
  ProposalFilter,
  BundleLocationState,
  BundleFilterOptions,
  BundleFilter,
};
